export default {"src":"/_next/static/media/custom-policy-design.366cdc1c.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};